export default "__VITE_ASSET__02$ZAqaW__"